import { http_client } from "@/plugins/http_client";


function getParams(params) {
    return params ? new URLSearchParams(Object.entries(params)).toString() : "";
}

const cifradoPresupuestario = {
    listar: ({params, data}) => http_client('/api/mnt_cifrado/search?' + getParams(params), data, 'post'),
    crear: (body) => http_client('/api/mnt_cifrado', body, 'post'),
    editar: (id, body) => http_client(`api/cifrado/${id}`, body, 'put'),
    desactivar: (body) => http_client("/api/mnt_cifrado/" + body.id, {}, 'delete'),
    cambiarEstado: (id, body) => http_client(`api/cifrado/${id}/estado`, body, 'put'),
};

const getUnidadesPresupuestarias = async () => {
    return await http_client("api/lista-unidades-presupuestarias", {}, "get");
};

const listarFF = () => {
    return http_client("/api/fuentes-financiamiento", {}, "get");
};

const listarFR = (params) => {
    return http_client("/api/v1/mnt-fuentes-recursos/activas", params, "get");
};

const listarPIP = (params) => {
    return http_client("/api/v1/proyectos", params, "get");
};

const listarAO = (params) => {
    return http_client("/api/v1/agrupadores", params, "get");
};

const listarCG = (params) => {
    return http_client("/api/v1/clasificacion-gastos", params, "get");
};



export default {
    cifradoPresupuestario,
    getUnidadesPresupuestarias,
    listarFF,
    listarFR,
    listarPIP,
    listarAO,
    listarCG
};

